<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.65109 21.1878C8.34109 21.1878 8.03609 21.0438 7.84009 20.7738L4.27209 15.8448C4.05209 15.5408 4.02109 15.1388 4.19209 14.8038C4.36209 14.4688 4.70709 14.2588 5.08209 14.2588H18.9191C19.4711 14.2588 19.9191 14.7068 19.9191 15.2588C19.9191 15.8108 19.4711 16.2588 18.9191 16.2588H7.04109L9.46009 19.6018C9.78409 20.0488 9.68409 20.6738 9.23609 20.9978C9.05909 21.1258 8.85409 21.1878 8.65109 21.1878Z"
      fill="#FAFAFA" />
    <path
      opacity="0.4"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.918 10.1164H5.08105C4.52905 10.1164 4.08105 9.66844 4.08105 9.11644C4.08105 8.56444 4.52905 8.11644 5.08105 8.11644H16.96L14.54 4.77344C14.216 4.32644 14.316 3.70044 14.764 3.37744C15.211 3.05344 15.836 3.15444 16.16 3.60044L19.728 8.53044C19.948 8.83444 19.98 9.23644 19.809 9.57144C19.638 9.90644 19.293 10.1164 18.918 10.1164Z"
      fill="#FAFAFA" />
  </svg>
</template>
